<template>
  <div style="width:100%">
    <a-row :gutter="[24, 8]">
      <a-col :span="8">
        <a-form-item
          label="民事加章费（个）"
          :wrapperCol="{ style: 'width:100%' }"
          :labelCol="{ style: 'width:120px' }"
        >
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'civilStampPrice',
                {
                  rules: [{ required: true, message: '请输入民事加章费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item
          label="商业加章费（个）"
          :wrapperCol="{ style: 'width:100%' }"
          :labelCol="{ style: 'width:120px' }"
        >
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'businessStampPrice',
                {
                  rules: [{ required: true, message: '请输入商业加章费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="单认证加急" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:120px' }">
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'simpleExpeditedPrice',
                {
                  rules: [{ required: true, message: '请输入单认证加急费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="8">
        <a-form-item label="双认证加急" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:120px' }">
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'doubleExpeditedPrice',
                {
                  rules: [{ required: true, message: '请输入双认证加急费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="单程快递费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:120px' }">
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'expressPrice',
                {
                  rules: [{ required: true, message: '请输入单程快递费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="服务费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:120px' }">
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'servicePrice',
                {
                  rules: [{ required: true, message: '请输入服务费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="24">
      <a-col :span="8">
        <a-form-item label="海牙加急费" :wrapperCol="{ style: 'width:100%' }" :labelCol="{ style: 'width:120px' }">
          <a-input-group compact>
            <a-input-number
              v-decorator="[
                'haiyaExpeditedPrice',
                {
                  rules: [{ required: true, message: '请输入海牙加急费' }],
                },
              ]"
              :min="0"
              :precision="2"
              style="width: 80%"
            />
            <div
              style="border:1px solid #dfdfdf;height:32px;line-height:32px;width:20%;background:#dfdfdf;text-align:center"
            >
              元
            </div>
          </a-input-group>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row :gutter="30">
      <a-col :span="12">
        <div>
          <a-form-item label="单认证价格、时长信息" required>
            <a-button style="width:200px;float:right" @click="addYiWen(1)">
              <a-icon type="plus-circle" />
              添加前往国家
            </a-button>
          </a-form-item>
          <div class="mt--20">
            <a-table
              class="queryView-table mt--10"
              :rowKey="useRowIndex"
              bordered
              :columns="tableColumns1"
              :dataSource="translationDataSource"
              :pagination="false"
              size="middle"
            ></a-table>
          </div>
        </div>
      </a-col>
      <a-col :span="12">
        <div>
          <a-form-item label="双认证价格、时长信息" required>
            <a-button style="width:200px;float:right" @click="addYiWen(2)">
              <a-icon type="plus-circle" />
              添加前往国家
            </a-button>
          </a-form-item>
          <div class="mt--20">
            <a-table
              class="queryView-table mt-2"
              :rowKey="useRowIndex"
              bordered
              :columns="tableColumns"
              :dataSource="certificateDataSource"
              :pagination="false"
              :scroll="{ x: '100%' }"
              size="middle"
            ></a-table>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="30">
      <a-col :span="24">
        <div>
          <a-form-item label="海牙认证价格信息" required>
            <a-button style="width:200px;float:right" @click="addYiWen(3)">
              <a-icon type="plus-circle" />
              添加前往国家
            </a-button>
          </a-form-item>
          <div class="mt--20">
            <a-table
              class="queryView-table mt--10"
              :rowKey="useRowIndex"
              bordered
              :columns="tableColumns2"
              :dataSource="haiyaDataSource"
              :pagination="false"
              size="middle"
            ></a-table>
          </div>
        </div>
      </a-col>
    </a-row>
    <AddPro ref="addPro"></AddPro>
    <SetAddress ref="setAddress"></SetAddress>
    <SetauthenticationType ref="SetauthenticationType"></SetauthenticationType>
  </div>
</template>
<script>
import AddPro from './AddNotarPro.vue'
import SetauthenticationType from './SetauthenticationType.vue'
import SetAddress from './SetAddress.vue'
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  props: {
    formData: {
      type: Object,
      require: true,
    },
    companyData: {
      type: Object,
      require: true,
    },
  },
  components: {
    AddPro,
    SetAddress,
    SetauthenticationType,
  },
  data() {
    const tableColumns = [
      {
        title: '前往国家',
        width: '100px',
        align: 'center',
        dataIndex: 'infoCountryName',
      },
      {
        title: '民事普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoCivilPrice',
      },
      {
        title: '商业普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoBusinessPrice',
      },
      // {
      //   title: '普通时长（工作日）',
      //   width: '200px',
      //   align: 'center',
      //   dataIndex: 'infoOrdinaryDuration',
      // },
      // {
      //   title: '加急时长（工作日）',
      //   width: '200px',
      //   align: 'center',
      //   dataIndex: 'infoUrgentDuration',
      // },
      {
        title: '有关规定',
        width: '200px',
        align: 'center',
        ellipsis: true,
        dataIndex: 'infoDescription',
      },
      {
        title: '操作',
        width: '100px',
        align: 'center',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.setPrice(row, index)
                }}
              >
                编辑
              </a>
              <app-icon
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow(row, index)
                }}
              ></app-icon>
            </div>
          )
        },
      },
    ]
    const tableColumns1 = [
      {
        title: '前往国家',
        width: '100px',
        align: 'center',
        dataIndex: 'infoCountryName',
      },
      {
        title: '民事普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoCivilPrice',
      },
      {
        title: '商业普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoBusinessPrice',
      },
      {
        title: '有关规定',
        width: '200px',
        ellipsis: true,
        align: 'center',
        dataIndex: 'infoDescription',
      },
      {
        title: '操作',
        width: '100px',
        align: 'center',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.setPrice1(row, index)
                }}
              >
                配置
              </a>
              <app-icon
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow1(row, index)
                }}
              ></app-icon>
            </div>
          )
        },
      },
    ]
    const tableColumns2 = [
      {
        title: '前往国家',
        width: '100px',
        align: 'center',
        dataIndex: 'infoCountryName',
      },
      {
        title: '民事普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoCivilPrice',
      },
      {
        title: '商业普通价格',
        width: '80px',
        align: 'center',
        dataIndex: 'infoBusinessPrice',
      },
      {
        title: '有关规定',
        width: '200px',
        ellipsis: true,
        align: 'center',
        dataIndex: 'infoDescription',
      },
      {
        title: '国家编码',
        width: '200px',
        ellipsis: true,
        align: 'center',
        dataIndex: 'correspondingNum',
      },
      {
        title: '操作',
        width: '100px',
        align: 'center',
        customRender: (text, row, index) => {
          return (
            <div class="flex gap-4 justify-center items-center text-primary-500">
              <a
                onClick={() => {
                  this.setPrice2(row, index)
                }}
              >
                配置
              </a>
              <app-icon
                type="icon-shanchu"
                onClick={() => {
                  this.removeRow2(row, index)
                }}
              ></app-icon>
            </div>
          )
        },
      },
    ]
    // 删除按钮

    return {
      tableColumns2: tableColumns2,
      tableColumns1: tableColumns1,
      tableColumns: tableColumns,
      translationDataSource: [],

      haiyaDataSource: [],
      certificateDataSource: [],
    }
  },
  computed: {
    typesMap() {
      return {}
    },
  },
  watch: {
    companyData: {
      immediate: true,
      handler(e) {
        this.dataList(e)
      },
    },
  },
  methods: {
    dataList(e) {
      if (e && e.baseId) {
        this.safeSetFieldsValue$t(this.formData, e)
        e.moreInfoList.forEach(element => {
          var objData = JSON.parse(JSON.stringify(element))
          if (objData.infoType === 1) {
            this.translationDataSource.push(objData)
          } else if (objData.infoType === 2) {
            this.certificateDataSource.push(objData)
          } else {
            this.haiyaDataSource.push(objData)
          }
        })
      }
    },
    getList() {
      return [...this.translationDataSource, ...this.certificateDataSource, ...this.haiyaDataSource]
    },
    async addYiWen(type) {
      const obj = await this.$refs.SetauthenticationType.start('', 'add', type)
      if (obj) {
        if (type === 1) {
          const isObj = this.translationDataSource.findIndex(v => v.infoCountryId === obj.infoCountryId)
          if (isObj > -1) {
            this.$message.error('列表中有相同国家')
            return
          }
          this.translationDataSource.push(obj)
        } else if (type === 2) {
          const isObj = this.certificateDataSource.findIndex(v => v.infoCountryId === obj.infoCountryId)
          if (isObj > -1) {
            this.$message.error('列表中有相同国家')
            return
          }
          this.certificateDataSource.push(obj)
        } else {
          const isObj = this.haiyaDataSource.findIndex(v => v.infoCountryId === obj.infoCountryId)
          if (isObj > -1) {
            this.$message.error('列表中有相同国家')
            return
          }
          this.haiyaDataSource.push(obj)
        }
      }
    },
    async addRow() {
      const list = await this.$refs.addPro.start()
      const data = list.map(row => {
        return {
          supplierCompanyId: this.companyData.companyId,
          supplierCompanyName: this.companyData.companyName,
          productId: row.productId,
        }
      })
      await this.$axios.post('/product-web-api/admin/product/addNotarization', {
        data,
      })
      this.$message.success('操作成功')
      this.loadList(this.companyId)
    },
    async removeRow2(row, index) {
      this.$confirm({
        title: '提示',
        content: '确定删除?',
        onOk: () => {
          this.haiyaDataSource.splice(index, 1)
          this.$message.success('操作成功!')
        },
        onCancel: () => {},
      })
    },
    async removeRow1(row, index) {
      this.$confirm({
        title: '提示',
        content: '确定删除?',
        onOk: () => {
          this.translationDataSource.splice(index, 1)
          this.$message.success('操作成功!')
        },
        onCancel: () => {},
      })
    },
    async removeRow(row, index) {
      this.$confirm({
        title: '提示',
        content: '确定删除?',
        onOk: () => {
          this.certificateDataSource.splice(index, 1)
          this.$message.success('操作成功!')
        },
        onCancel: () => {},
      })
    },
    async setPrice(row) {
      const obj = await this.$refs.SetauthenticationType.start(row, 'edit', 2)
      if (obj) {
        row.infoCivilPrice = obj.infoCivilPrice
        row.infoBusinessPrice = obj.infoBusinessPrice
        row.infoOrdinaryDuration = obj.infoOrdinaryDuration
        row.infoType = obj.infoType
        row.infoUrgentDuration = obj.infoUrgentDuration
        row.infoDescription = obj.infoDescription
      }
    },
    async setPrice1(row) {
      const obj = await this.$refs.SetauthenticationType.start(row, 'edit', 1)
      if (obj) {
        this.$nextTick(() => {
          row.infoCivilPrice = obj.infoCivilPrice
          row.infoBusinessPrice = obj.infoBusinessPrice
          row.infoType = obj.infoType
          row.infoOrdinaryDuration = obj.infoOrdinaryDuration
          row.infoUrgentDuration = obj.infoUrgentDuration
          row.infoDescription = obj.infoDescription
        })
      }
    },
    async setPrice2(row) {
      const obj = await this.$refs.SetauthenticationType.start(row, 'edit', 3)
      if (obj) {
        this.$nextTick(() => {
          row.infoCivilPrice = obj.infoCivilPrice
          row.infoBusinessPrice = obj.infoBusinessPrice
          row.infoType = obj.infoType
          row.infoOrdinaryDuration = obj.infoOrdinaryDuration
          row.infoUrgentDuration = obj.infoUrgentDuration
          row.infoDescription = obj.infoDescription
          row.correspondingNum = obj.correspondingNum
        })
      }
    },
    async setAddress(row) {
      const data = await this.$refs.setAddress.start(row)
      await this.$axios.post('/product-web-api/admin/product/setNotarizationAddress', {
        data: data,
      })
      this.$message.success('操作成功')
      this.loadList()
    },
    async loadList() {
      this.dataList()
    },
  },
  created() {
    console.log('created')
    // this.loadList()
  },
  mounted() {
    console.log('mounted')
    // this.loadList()
  },
}
</script>
<style lang="less" scoped>
.mt--10 {
  margin-top: -14px;
  margin-bottom: 24px;
}
.mt--20 {
  margin-top: -24px;
  margin-bottom: 24px;
}
</style>
